export default {"src":"/_next/static/media/feature1.ead20d24.svg","height":42,"width":42};